import { styled } from "@mui/material";

const PageSection = styled("div")(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

export default PageSection;
